export const MIN_COLUMN_SIZE = 120;
export const MAX_COLUMN_SIZE = 500;
export const SIDE_NAV_AND_GAPS_SIZE = 420;
